import * as THREE from 'three';

import { GlobalConfig } from 'config/global';
import Player from 'entities/player';
import Ball from 'entities/ball';
import Floor from 'entities/floor';
import Arena from 'entities/arena';

import KeyInput from '../keyInput';
import Label from 'ui/label';
import ScoreLabel from 'ui/scoreLabel';
import HitArea from 'ui/hitArea';


const COLOURS = [
  0x336699,
  0x99CC33,
  0x66FF33,
  0xFFFFFF,
  0xCCCC33
];
const BALL_SPEED = 5;

const PLAYER_Z = 300;

export default class GameplayState extends THREE.Scene {
  constructor (renderer) {
    super();
    this.renderer = renderer;

    const fov = 60;
    this.camera = new THREE.PerspectiveCamera(fov, renderer.getSize().width / renderer.getSize().height, 0.1, 10000);

    this.camera.position.set(0, 400, 200);
    this.camera.lookAt(new THREE.Vector3(0,0,-400));
    this.add(this.camera);

    this.floor = new Floor(new THREE.Vector3(0, 0, -250), 1000, 1000, 20, 20, 0xAAAAAA, 0x333333);
    this.floor.rotation.x = - Math.PI / 2
    this.add(this.floor);

    this.arena = new Arena();
    this.add(this.arena);

    this.playerOne = new Player(new THREE.Vector3(0, 50, -600), 0xCC6633);
    this.playerTwo = new Player(new THREE.Vector3(0, 50, -100), 0x6633CC);

    this.score = {
      playerOne: 0,
      playerTwo: 0,
      rally: 0,
      bestRally: 0
    }

    this.currentRallyLabel = new ScoreLabel(50, 50, '#CC6633');
    this.currentRallyLabel.setText(`Rally: ${this.score.rally}`);
    this.bestRallyLabel = new ScoreLabel(1024 - 50 - 240, 50, '#6633CC');
    this.bestRallyLabel.setText(`Best: ${this.score.bestRally}`);

    this.ball = new Ball(new THREE.Vector3(0, 50, -PLAYER_Z));

    this.add(this.playerOne);
    this.add(this.playerTwo);
    this.add(this.ball);

    setTimeout(this._initInput.bind(this), 0);
    this._initLight();
  }

  update (t) {
    if (this.input) {
      this.input.update();
      this.hitAreaPlayerOne.update();
      this.hitAreaPlayerTwo.update();
    }

    this.checkBallHitPlayer(this.playerOne, this.ball);
    this.checkBallHitPlayer(this.playerTwo, this.ball);

    this.checkBallHitWall(this.ball);
    this.checkWallHitPlayer(this.playerOne);
    this.checkWallHitPlayer(this.playerTwo);

    this.checkBallHitGoal();

    // updates
    this.ball.update(t);
    this.playerOne.update(t);
    this.playerTwo.update(t);

  }

  checkBallHitWall (ball) {
    switch (this.arena.hitWall(ball)) {
      case 'left':
      ball.position.x = this.arena.leftWall.right + ball.r;
      ball.velocity.x *= -1;
      break;

      case 'right':
      ball.position.x = this.arena.rightWall.left - ball.r;
      ball.velocity.x *= -1;
      break;
    }
  }

  checkWallHitPlayer (player) {
    switch (this.arena.hitWall(player)) {
      case 'left':
      player.position.x = this.arena.leftWall.right + player.width / 2;
      break;

      case 'right':
      player.position.x = this.arena.rightWall.left - player.width / 2;
      break;
    }
  }

  checkBallHitPlayer (player, ball) {
    const activePlayerFace = ball.velocity.z > 0 ? 'back' : 'front';
    const playerAABB = new THREE.Box3().setFromObject(player);
    const ballAABB = new THREE.Box3().setFromObject(ball);

    if (ballAABB.intersectsBox(playerAABB)) {
      ball.position.z = player[activePlayerFace] + (ball.velocity.z > 0 ? -ball.r : ball.r); //tTODOs
      const relativeHitPoint = new THREE.Vector3(
        ball.position.x - player.position.x,
        ball.position.y - player.position.y,
        ball.position.z - player.position.z
      );
      ball.bounce(relativeHitPoint);
      this.currentRallyLabel.setText(`Rally: ${++this.score.rally}`);

      // if (this.rightWall.position.x - this.leftWall.position.x > this.playerOne.width) {
        this.arena.narrowBy(20);
      // }
    }
  }

  checkBallHitGoal () {
    if (!this.ball.alive) return;
    let goal = false;
    if (this.ball.position.z < (this.playerOne.position.z - this.playerOne.depth * 6)) {
      this.score.playerTwo++;
      this.ball.alive = false;
      goal = true;

    }
    if (this.ball.position.z > (this.playerTwo.position.z + this.playerTwo.depth * 6)) {
      this.score.playerOne++;
      this.ball.alive = false;
      goal = true;

    }

    if (goal) {
      this.arena.reset();
      this.score.bestRally = Math.max(this.score.bestRally, this.score.rally);
      this.score.rally = 0;
      this.currentRallyLabel.setText(`Rally: ${this.score.rally}`);
      this.bestRallyLabel.setText(`Best: ${this.score.bestRally}`);

      setTimeout(() => {
        this.ball.reset();
      }, 500);
    }
  }

  movePlayer (player, vector) {
    for (let axis in vector) {
      player.velocity[axis] = vector[axis];
    }
  }

  handleMobileInput (player, touchX) {
    // const playerPos = player.position.clone();
    // const canvas = this.renderer.context.canvas;
    // playerPos.project(this.camera);
    // playerPos.x = Math.round( (   playerPos.x + 1 ) * canvas.width  / 2 );
    const playerPos = this.getScreenPosition(player);

    if (touchX + 20 < playerPos.x) {
      this.movePlayer(player, {x: -5})
    } else if (touchX - 20 > playerPos.x) {
      this.movePlayer(player, {x: 5})
    }

  }

  getScreenPosition (object) {
    const playerPos = object.position.clone();
    const canvas = this.renderer.context.canvas;
    playerPos.project(this.camera);

    return {
      x: Math.round((playerPos.x + 1) * canvas.width  / 2),
      y: Math.round( ( - playerPos.y + 1 ) * canvas.height / 2 )
    }
  }

  _initInput () {
    this.hitAreaPlayerOne = new HitArea(0, this.getScreenPosition(this.playerTwo).y - 50, this.renderer.getSize().width, 100, this.handleMobileInput, this, this.playerTwo);
    this.hitAreaPlayerTwo = new HitArea(0, this.getScreenPosition(this.playerOne).y - 50, this.renderer.getSize().width, 100, this.handleMobileInput, this, this.playerOne);
    // this.hitAreaPlayerTwo = new HitArea(0, 150, this.renderer.getSize().width, 100, () => {this.movePlayer(this.playerTwo, {x: -5}); });

    this.input = new KeyInput();
    this.input.bindKey('left', this.movePlayer, this, this.playerOne, {x: -5});
    this.input.bindKey('right', this.movePlayer, this, this.playerOne, {x: 5});
    // this.input.bindKey('up', this.movePlayer, this, this.playerOne, {y: 5});
    // this.input.bindKey('down', this.movePlayer, this, this.playerOne, {y: -5});

    this.input.bindKey('a', this.movePlayer, this, this.playerTwo, {x: -5});
    this.input.bindKey('d', this.movePlayer, this, this.playerTwo, {x: 5});
  //   this.input.bindKey('w', this.movePlayer, this, this.playerTwo, {y: 5});
  //   this.input.bindKey('s', this.movePlayer, this, this.playerTwo, {y: -5});
  }

  _initLight () {
    const pointLight = new THREE.SpotLight(0xFFFFFF);
    pointLight.position.set(10, 800, -200);

    pointLight.target.position.set(10, 0, -200);
    pointLight.castShadow = true;

    pointLight.shadow.mapSize.width = 1024;
    pointLight.shadow.mapSize.height = 1024;

    pointLight.shadow.camera.near = 500;
    pointLight.shadow.camera.far = 40000;
    pointLight.shadow.camera.fov = 45;

    this.add(pointLight);
  }
}



// WEBPACK FOOTER //
// ./src/state/gameplay.js